import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SelectedRoom {
  id: number | null;
}

export interface SelectedDevice {
  productNameId: string | null;
  productId: number | null;
}

export interface PlannerUiState {
  selectedFloorId: number | null,
  selectedRoom: SelectedRoom,
  selectedDevice: SelectedDevice,
  pendingScaleSetupFloorId: number | null,
  scaleSetupCompletedFloorId: number | null,
  roomDetectedModalShown: boolean,
  openFloorWizardAfterProjectCreation: boolean,
  isFullscreen: boolean,
  firstWalkthroughOfferPending: boolean,
}

const initialState: PlannerUiState = {
  selectedFloorId: null,
  selectedRoom: { id: null },
  selectedDevice: { productNameId: null, productId: null },
  pendingScaleSetupFloorId: null,
  scaleSetupCompletedFloorId: null,
  roomDetectedModalShown: false,
  openFloorWizardAfterProjectCreation: false,
  isFullscreen: false,
  firstWalkthroughOfferPending: false,
}

export const plannerUiSlice = createSlice({
  name: 'plannerUi',
  initialState,
  reducers: {
    setSelectedFloorId: (state, action: PayloadAction<number | null>) => {
      state.selectedFloorId = action.payload;
    },
    setSelectedRoom: (state, action: PayloadAction<SelectedRoom>) => {
      state.selectedRoom = action.payload;
    },
    setSelectedDevice: (state, action: PayloadAction<SelectedDevice>) => {
      state.selectedDevice = action.payload;
    },
    setPendingScaleSetupFloorId: (state, action: PayloadAction<number | null>) => {
      state.pendingScaleSetupFloorId = action.payload;
    },
    setScaleSetupCompletedFloorId: (state, action: PayloadAction<number | null>) => {
      state.scaleSetupCompletedFloorId = action.payload;
    },
    setRoomDetectedModalShown: (state, action: PayloadAction<boolean>) => {
      state.roomDetectedModalShown = action.payload;
    },
    setOpenFloorWizardAfterProjectCreation: (state, action: PayloadAction<boolean>) => {
      state.openFloorWizardAfterProjectCreation = action.payload;
    },
    setIsFullscreen: (state, action: PayloadAction<boolean>) => {
      state.isFullscreen = action.payload;
    },
    setFirstWalkthroughOfferPending: (state, action: PayloadAction<boolean>) => {
      state.firstWalkthroughOfferPending = action.payload;
    },
  }
})